import { useEffect } from "react";
import { useUser } from "../../../../../../contexts/userContext/userContext";
import type { BillingDetailsT } from "../../../../../../models/models";
import useTransaction from "../../../hooks/useTransaction";
import checkPaypalButtonShouldBeShown from "../helpers/checkPaypalButtonShouldBeShown";

/**
 * Custom hook that determines whether to show the PayPal button based on the user's billing details.
 * @returns {boolean} A boolean value indicating whether to show the PayPal button.
 */

const useShowPayPalButton = () => {
  const { getUserBillingDetails } = useUser();
  const billingDetails = getUserBillingDetails() as BillingDetailsT;
  const subscriptionPaymentMethod = billingDetails?.payment_gateway;
  const addonPaymentMethod = billingDetails?.addons?.[0]?.payment_method;
  const { checkIfSubscriptionPurchase, isSubscriptionPurchase } =
    useTransaction();

  useEffect(() => {
    // Check if it is a subscription purchase or an addon purchase
    checkIfSubscriptionPurchase();
  }, [checkIfSubscriptionPurchase]);

  const showButton = checkPaypalButtonShouldBeShown(
    isSubscriptionPurchase,
    subscriptionPaymentMethod,
    addonPaymentMethod
  );

  return showButton;
};

export default useShowPayPalButton;
